import React from 'react';
import { useDispatch } from 'react-redux';
import { addEdgeToDecisionTreePath } from 'actions/searchActions';
import { NoMatchText, MacroButton } from 'components/DecisionTree/DecisionTree.styles';

const NoStoreSearchResults = (props) => {
  const dispatch = useDispatch();

  return (
    <>
      <NoMatchText marginTop={'10px'}>Next steps you can take:</NoMatchText>
      <NoMatchText marginTop={'10px'}>
        1. You can also try searching by the customer's zip code or street address number.
      </NoMatchText>
      <NoMatchText marginTop={'7px'}>
        2. If you still can't find a result, please click "Get Macro" below for steps to help the customer locate their
        store
      </NoMatchText>
      <MacroButton active={true} onClick={() => dispatch(addEdgeToDecisionTreePath('no_search_results'))}>
        GET MACRO
      </MacroButton>
      <NoMatchText marginTop={'0px'}>
        3. Once you have received a response from the customer, use the updated <br />
        customer information to search again.
      </NoMatchText>
    </>
  );
};

export default NoStoreSearchResults;
